// providers/QueryProvider.jsx
// React Query Provider - Synchronized with Mobile App
import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client with optimized settings for speed & security
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes - data stays fresh
      gcTime: 1000 * 60 * 15, // 15 minutes - garbage collection
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: true,
      networkMode: 'online',
    },
    mutations: {
      retry: 1,
    },
  },
});

// Make queryClient accessible globally for logout clearing
if (typeof window !== "undefined") {
  window.queryClient = queryClient;
}

export const QueryProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

export { queryClient };

